import React from 'react';

const services = [
  {
    icon: 'fa-solid fa-code',
    title: 'Web Development',
    desc: 'Performant web applications built with React, Next.js, and Node.js. Optimized for speed, SEO, and conversion rates that drive growth.',
    delay: 'rv-d1',
  },
  {
    icon: 'fa-solid fa-mobile-screen-button',
    title: 'App Development',
    desc: 'Native iOS and Android apps plus cross-platform solutions with React Native and Flutter. Pixel-perfect interfaces with rock-solid performance.',
    delay: 'rv-d2',
  },
  {
    icon: 'fa-solid fa-pen-ruler',
    title: 'UI/UX Design',
    desc: 'Research-driven interface design, interactive prototyping, and design systems. We create experiences users remember and return to.',
    delay: 'rv-d3',
  },
  {
    icon: 'fa-solid fa-cloud',
    title: 'Cloud Architecture',
    desc: 'Scalable infrastructure on AWS, GCP, and Azure. We design serverless architectures, CI/CD pipelines, and auto-scaling deployments.',
    delay: 'rv-d4',
  },
  {
    icon: 'fa-solid fa-chart-mixed',
    title: 'Digital Strategy',
    desc: 'Data-driven product strategy, analytics implementation, and growth optimization. We turn business goals into measurable digital outcomes.',
    delay: 'rv-d5',
  },
  {
    icon: 'fa-solid fa-microchip',
    title: 'AI Integration',
    desc: 'Custom ML models, intelligent automation, and LLM-powered features. We embed AI where it creates the most competitive advantage.',
    delay: 'rv-d6',
  },
];

function Services() {
  return (
    <section id="services" className="section">
      <div className="accent-orb" style={{ width: 400, height: 400, bottom: 0, left: -200, animationDelay: '2s' }}></div>
      <div className="section-inner">
        <div className="section-header-split">
          <div className="rv">
            <span className="label-tag" style={{ marginBottom: '1.5rem', display: 'block' }}>Services</span>
            <h2 className="section-title">End-to-end digital solutions for modern businesses</h2>
          </div>
          <div className="section-header-right rv rv-d2">
            <p className="section-desc">
              We handle everything from initial strategy to final deployment. Our multidisciplinary team ensures every layer of your product is crafted with precision.
            </p>
          </div>
        </div>

        <div className="svc-grid">
          {services.map((svc, i) => (
            <div key={i} className={`svc-card rv ${svc.delay}`}>
              <div className="svc-icon-box"><i className={svc.icon}></i></div>
              <h3>{svc.title}</h3>
              <p>{svc.desc}</p>
              <a href="#contact" className="svc-card-link">
                Explore <i className="fa-solid fa-arrow-right"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
